import React, { Component } from "react";

export default class Certification extends Component {
  render() {
    return (
      <div>User Certification would be placed (Probably make component)</div>
    );
  }
}
